import { stringDateToPP } from "@/util/date";

import type { DecoratedPersonEfteruddannelse } from "./decoratePeriod";

export const formatEfteruddannelsePeriodLabel = (
  period: DecoratedPersonEfteruddannelse,
): string =>
  `${stringDateToPP(period.periode.fraDato)} – ${stringDateToPP(period.periode.tilDatoInklusiv)}`;

export const buildPeriodLabelLookup = (
  periods: DecoratedPersonEfteruddannelse[],
): Map<string, string> =>
  new Map(
    periods.map((period) => [
      period.id,
      formatEfteruddannelsePeriodLabel(period),
    ]),
  );

export const formatDispensationPeriodLabel = (
  periodId: string,
  lookup: Map<string, string>,
): string => lookup.get(periodId) ?? periodId;
